import api from './api';

export function getCourses() {
  return api.get(`/api/v2/courses`);
}

export function getStations() {
  return api.get('/api/v2/courses/connections/locations/candidates');
}

export function getCourseConnectionsLocations() {
  return api.get('/api/v2/courses/connections/locations');
}

export function deactivateCourseConnectionLocation(locationId) {
  return api.delete(`/api/v2/courses/connections/locations/${locationId}`);
}

export function activateStation(sloid) {
  return api.post('/api/v2/courses/connections/locations', {
    sloid,
  });
}

export function getNextCourses() {
  return api.get('/api/v2/courses?is_public=1&next_connections=1&limit=75');
}

export function blockCourse(courseId) {
  return api.put(`/api/v2/courses/${courseId}/connection`, {
    is_blocked: true,
    delay_minutes: 0,
  });
}

export function releaseCourse(courseId) {
  return api.put(`/api/v2/courses/${courseId}/connection`, {
    is_blocked: false,
    delay_minutes: 0,
  });
}

export function delayDeparture(courseId, delay) {
  return api.put(`/api/v2/courses/${courseId}/connection`, {
    is_blocked: false,
    delay_minutes: delay,
  });
}
